import * as React from "react";

import { ResponsivenessSetting, useResponsiveness } from "../hooks";

import {
  usePlpPresenterForTheFilterMenu_Desktop,
  useProductListState,
} from "../providers";

import { DesktopFilterMenu } from "../desktop-filter-menu";

import { Content } from "./content";
import { AppliedFilters } from "../desktop-filter-menu/applied-filters";
import { IS_HORIZONTAL_FILTER_ENABLED } from "../flags";

export const MainContent: React.FunctionComponent = () => {
  const [responsivenessSetting] = useResponsiveness();

  const { shouldShowTheFilterMenu_onDesktop } =
    usePlpPresenterForTheFilterMenu_Desktop();

  const showDesktopFilters =
    responsivenessSetting === ResponsivenessSetting.Desktop &&
    shouldShowTheFilterMenu_onDesktop;

  const { selectedOptions } = useProductListState();

  return (
    <div
      className={`main-content ${
        showDesktopFilters ? "show-filter-menu" : "hide-filter-menu"
      }`}
    >
      {showDesktopFilters && <DesktopFilterMenu />}
      {IS_HORIZONTAL_FILTER_ENABLED && selectedOptions && <AppliedFilters />}
      <Content />
    </div>
  );
};
